import NewsletterModalController from "./newsletter_modal_controller"
import NavController from "./nav_controller"

export function registerControllers(application) {
  application.register("newsletter-modal", NewsletterModalController)
  application.register("nav", NavController)
}
